import { Button } from '@cluey/cluey-components';
import { Link } from 'react-router-dom';

import { PricePlan } from '../../../../../types/hubTypes';
import { PATH_HUB_CHANGE_PLAN } from '../../../../../util/pagePath';
import { PRICING_PLAN_ROWS, showChangePlanButton, useHasActiveGroupEnrolments } from '../../../helpers';

export const PLAN_DETAILS_SECTION_ID = 'plan-details-section';

export type PricingPlanDetailsSectionProps = {
  plan: PricePlan;
  chipContent?: string;
};

const PricingPlanDetailsSection = ({ plan, chipContent }: PricingPlanDetailsSectionProps) => {
  const hasGroupEnrolments = useHasActiveGroupEnrolments();
  return (
    <div
      className="flex w-full scroll-mt-14 flex-col overflow-hidden md:flex-row lg:scroll-mt-20"
      id={PLAN_DETAILS_SECTION_ID}
    >
      <div className="relative flex basis-1/3 flex-col items-center justify-center rounded-tl-3xl rounded-tr-3xl border border-grey-2 bg-brown-200 px-4 py-8 md:rounded-bl-3xl md:rounded-tr-none">
        {chipContent && (
          <div className="absolute right-3 top-3 flex items-center justify-center rounded-lg bg-blood-orange-4 p-2 text-sm font-bold leading-3 text-white md:top-3 md:h-auto md:p-4">
            {chipContent}
          </div>
        )}
        <div className="proxima-nova mt-4 text-xl font-bold text-grey-600 md:text-2xl">
          {plan.pricingPlanDisplayName}
        </div>
        <div className="proxima-nova text-5xl font-bold text-grey-600">${plan.privatePriceTier.costPerSession}</div>
        <div className="proxima-nova text-base font-bold text-grey-600">per session</div>
        {hasGroupEnrolments && (
          <div className="mt-5 text-xs text-grey-4">${plan.groupPriceTier.costPerSession} per group session</div>
        )}
      </div>
      <div className="flex basis-2/3 flex-col justify-start rounded-bl-3xl rounded-br-3xl border border-grey-2 bg-white px-10 py-8 align-middle md:rounded-bl-none md:rounded-tr-3xl">
        <div className="mb-4 font-proxima-soft text-xs font-bold tracking-[1px]">PLAN POLICY</div>
        <div className="flex flex-col">
          {PRICING_PLAN_ROWS.map((row) => (
            <div key={row.header} className="flex flex-col border-b border-grey-2 py-3 last:border-none lg:flex-row">
              <div className="proxima-soft flex basis-1/2 text-base font-bold text-grey-600">
                {row.getHeader(plan, hasGroupEnrolments)}
              </div>
              <div className="flex basis-1/2 text-grey-600">{row.getContent(plan, hasGroupEnrolments)}</div>
            </div>
          ))}
        </div>
        <div className="mt-4 text-sm text-grey-500">
          The cancellation or change of plan can only take effect after the last paid session
        </div>
        {showChangePlanButton(plan) && (
          <div className="mt-6">
            <Link to={PATH_HUB_CHANGE_PLAN}>
              <Button className="w-full md:w-auto" appearance="reverse">
                Change plan
              </Button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};
export default PricingPlanDetailsSection;
